export default {
  form: {
    address: {
      delivery: {
        placeholder: 'Suche deine Lieferadresse',
      },
      placeholder: 'Deine Adresse eingeben',
    },
  },
  toasts: {
    failed_to_load_stores: 'Fehler beim Laden von Store, bitte aktualisiere die Seite',
  },
  errors: {
    no_delivery_companies: 'Lieferung für diese Adresse nicht verfügbar',
    delivery_not_available: 'Leider bieten wir derzeit keine Lieferung an',
    location_unavailable:
      'Standort konnte nicht abgerufen werden, bitte erlaube den Zugriff oder gib die Adresse manuell ein',
    location_lookup_failed: 'Adresse konnte nicht ermittelt werden, bitte erneut versuchen',
    address_suggestions_unavailable: 'Adressvorschläge konnten nicht geladen werden.',
  },
  buttons: {
    use_current_location: 'Aktuellen Standort verwenden',
    locating: 'Standort wird gesucht…',
    retry: 'Erneut versuchen',
  },
};
